import { useApplicationContext } from './use-application-context';

export const useHasRole = (...roles: string[]): boolean =>
    useApplicationContext()
        .applicationState.myUserProfile.map((profile) => roles.some((role) => profile.roles?.includes(role) === true))
        .unwrapOr(false);
